import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { getTranslation } from '../utils/translations';
import useJWT from '../utils/useJWT';

const NavBarCognito = () => {
  const [_, setJWT] = useJWT();
  const switchAccountText = getTranslation('switchAccount');
  const redirectUrl = process.env.REACT_APP_DASHBOARD_LOGIN_URL;

  const logout = () => {
    setJWT(null);
    window.location.href = redirectUrl;
  };

  return (
    <Navbar bg="transparent" className="mr-auto">
      <img
        src={`./${process.env.REACT_APP_BRAND}/logo.svg`}
        alt="logo"
        className="navbar-logo"
      />
      <div>
        <button className="logout-btn" onClick={() => logout()}>
          {switchAccountText}
        </button>
      </div>
    </Navbar>
  );
};

export default NavBarCognito;
